import React, { useState, useEffect } from 'react';
import axios from 'axios';
import io from 'socket.io-client';
import CryptoJS from 'crypto-js';
import ReactJson from 'react-json-view';
import Select from 'react-select';
import "../.././styles/LogMonitor.css";
import { useDispatch, useSelector } from 'react-redux';
import AccessDenied from '../OtherComponents/AccessDenied';
import { Button, Grid, Stack } from "../../styles/MaterialUI";
import apiConstants, { SOCKET_IO_URL } from '../../constants/apiConstants';
import { showAlertPopup } from '../Redux/Features/showAlertSlice';

let socket;
const Troubleshoot = ({ disableCallOut }) => {
    const { userToken } = useSelector((state) => state.userToken);
    const { isInternalUser } = useSelector((state) => state.userLogin);
    const [screenUiid, setScreenUiid] = useState('');
    const [buttonName, setButtonName] = useState('Connect');
    const [logs, setLogs] = useState([]);
    const [historylogs, setHistoryLogs] = useState([]);
    const [expandedLogs, setExpandedLogs] = useState({});
    const [options, setOptions] = useState([]);
    const [connected, setConnected] = useState(false);
    const dispatch = useDispatch();

    function repairJsonString(jsonString) {
        // Remove trailing commas before a closing brace or bracket
        jsonString = jsonString.replace(/,\s*([}\]])/g, '$1');

        // Add more specific repairs as needed
        // Example: Fix unquoted keys (optional and may vary based on your JSON format)
        jsonString = jsonString.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?\s*:/g, '"$2":');

        return jsonString;
    }

    useEffect(() => {
        const fetchScreens = async () => {
            try {
                const req_payload = {};
                const response = await axios.post(`${apiConstants.GET_API_URL}getScreenNames`,
                    req_payload,
                    {
                        headers: {
                            Authorization: `Bearer ${userToken}`,
                        },
                    }
                );
                if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                    const newOptions = response.data.data.map(screen => ({
                        value: screen.screen_uiid,
                        label: screen.ic_screen_name
                    }));
                    newOptions.sort((a, b) => a.label.localeCompare(b.label));

                    setOptions(newOptions);
                } else {
                    console.error('Unexpected response format:', response.data);
                }
            } catch (error) {
                console.error('Error fetching screens:', error);
            }
        };

        fetchScreens();
    }, []);

    const toggleLog = (index) => {
        setExpandedLogs((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    const handleScreenUiidChange = (selectedOption) => {
        setScreenUiid(selectedOption ? selectedOption.value : '');
        if (socket) {
            socket.disconnect();
            setConnected(false);
            socket = null;
        }
    };

    const addLog = (eventName, message, type) => {
        const timestamp = new Date().toLocaleString();
        setLogs(prevLogs => {
            const newLog = { eventName, message, type, timestamp, originalIndex: prevLogs.length };
            return [...prevLogs, newLog];
        });
    };

    const historyLogs = (eventName, message, type) => {
        const timestamp = new Date().toLocaleString();
        setHistoryLogs(prevLogs => {
            const newLog = { eventName, message, type, timestamp, originalIndex: prevLogs.length };
            return [...prevLogs, newLog];
        });
    };

    const initializeSocket = async () => {
        try {
            if (!socket) {
                setLogs([]);
                setHistoryLogs([]);
                setExpandedLogs({});
                socket = io(SOCKET_IO_URL.API_URL, {
                    extraHeaders: {
                        screenuiid: screenUiid,
                    },
                });

                let aesKey = '';
                const req_payload = { screen_uiid: screenUiid };
                try {
                    const response = await axios.post(`${apiConstants.GET_API_URL}getScreenAESKey`,
                        req_payload,
                        {
                            headers: {
                                Authorization: `Bearer ${userToken}`,
                            },
                        }
                    );
                    if (response.data && response.data.status === 'success') {
                        aesKey = response.data.data.key;
                        //console.log("aesKey", aesKey);
                    }
                    else {
                        console.error('Unexpected response format:', response.data);
                    }
                }
                catch (error) {
                    console.log("error", error);
                }

                socket.on('connect', async () => {
                    addLog('connectCast', { screen_uiid: screenUiid }, 'to');
                    socket.emit('connectCast', { screen_uiid: screenUiid });
                    try {
                        const response_logs = await axios.post(`${apiConstants.GET_API_URL}getScreenLogs`,
                            req_payload,
                            {
                                headers: {
                                    Authorization: `Bearer ${userToken}`,
                                },
                            }
                        );

                        if (response_logs && response_logs.data.statusCode == "200") {
                            let response_logsdata = response_logs;
                            let logsArray = response_logsdata.data.logContents;

                            if (Array.isArray(logsArray)) {
                                for (const file of logsArray) {
                                    let logs = file.content.split(" - ", 2);
                                    if (logs.length === 2) {
                                        // let repairedJson = repairJsonString(logs[1]); // Repair the JSON string
                                        // let logData = JSON.parse(repairedJson.trim()); // Parse the repaired JSON string
                                        let date = new Date(logs[0]);
                                        let formattedDate = date.toLocaleString();
                                        historyLogs('Logs on ' + formattedDate, { screen_uiid: screenUiid, logs: logs[1] }, 'to');

                                    } else {
                                        console.error('Unexpected log format:', file.content);
                                    }
                                    console.log("response_logs", logsArray);
                                }
                            }
                        }
                    }
                    catch (error) {
                        console.log("error", error);
                    }
                });

                socket.on('contentUpdated', ({ message, change_category, content_id, content_status, content_type }) => {
                    // const logMessage = `Received content changed event: {message: ${message}, change_category: ${change_category}, content_id: ${content_id}, content_status: ${content_status}, content_type: ${content_type}}`;
                    addLog('contentUpdated', { message, change_category, content_id, content_status, content_type }, 'from');
                    if (content_type === "content_playlist") {
                        if (change_category == "playlist_changes") {
                            socket.emit('castRequest', { screen_uiid: screenUiid, requested_category: change_category, content_id: content_id });
                            addLog('castRequest', { screen_uiid: screenUiid, request_type: "forced_content" }, 'to');
                        } else {
                            socket.emit('contentRequest', { screen_uiid: screenUiid, requested_category: change_category, content_id: content_id });
                            addLog('contentRequest', { screen_uiid: screenUiid, requested_category: change_category, content_id: content_id }, 'to');
                        }
                    } else {
                        socket.emit('castRequest', { screen_uiid: screenUiid, requested_category: change_category, content_id: content_id });
                        addLog('castRequest', { screen_uiid: screenUiid, request_type: "forced_content" }, 'to');
                    }
                });

                socket.on('streamContentToDevice', (encryptedData) => {
                    const decryptedData = decryptData(encryptedData.encryptedData, aesKey, encryptedData.iv);

                    addLog('streamContentToDevice', JSON.parse(decryptedData), 'from');
                    socket.emit('streamDataReceived', { screen_uiid: screenUiid, timestamp: new Date() });
                    addLog('streamDataReceived', { screen_uiid: screenUiid, timestamp: new Date() }, 'to');
                });

                socket.on('requestBaseJson', (data) => {
                    addLog('requestBaseJson', `requestBaseJson: ${JSON.stringify(data)}`);
                    let base_json = {
                        // Your base_json content here...
                    };
                    socket.emit('responseBaseJson', { screen_uiid: screenUiid, timestamp: new Date(), base_json: base_json });
                });

                socket.on('streamDataToDevice', (encryptedData) => {
                    if (encryptedData && encryptedData.encryptedData && encryptedData.iv) {
                        const decryptedData = decryptData(encryptedData.encryptedData, aesKey, encryptedData.iv);

                        addLog('streamDataToDevice', JSON.parse(decryptedData), 'from');
                        socket.emit('streamDataReceived', { screen_uiid: screenUiid, timestamp: new Date() });
                        addLog('streamDataReceived', { screen_uiid: screenUiid, timestamp: new Date() }, 'to');
                    } else {
                        addLog('streamDataToDevice', `Invalid encryptedData object received: ${JSON.stringify(encryptedData)}`);
                    }
                });

                socket.on('connectCastResponse', (data) => {
                    setConnected(true);
                    addLog('connectCastResponse', data, 'from');
                    setButtonName("Connect");
                });

                socket.on('screenAdded', (data) => {
                    addLog('screenAdded', data, 'from');
                });

                socket.on('screenStatusChange', (data) => {
                    addLog('screenStatusChange', data, 'from');
                    const { screen_uiid, updated_status } = data;
                    socket.emit('screenStatusReceived', { screen_uiid: screen_uiid, requested_category: updated_status });
                    addLog('screenStatusReceived', { screen_uiid: screenUiid, processed_status: updated_status }, 'to');
                });

                socket.on('disconnect', () => {
                    addLog('Disconnect', { message: "Disconnected from server" }, 'from');
                });
            }
        }
        catch (error) {
            console.log(error)
        }
    };

    const handleRequestData = async () => {
        if (!screenUiid) {
            dispatch(showAlertPopup({ isOpen: true, severity: "error", message: "Please select screen name" }));
            return;
        }
        initializeSocket();
        disableCallOut(true);
    };

    const handleDisconnectClick = () => {
        if (socket) {
            socket.disconnect();
            setConnected(false);
            socket = null;
            setLogs([]);
            setHistoryLogs([]);
            disableCallOut(false);
        }
    };

    const decryptData = (encryptedData, aesKey, iv) => {
        try {
            aesKey = CryptoJS.enc.Base64.parse(aesKey); // Convert base64-encoded AES key to WordArray
            iv = CryptoJS.enc.Hex.parse(iv); // Convert hex-encoded IV to WordArray

            const decryptedData = CryptoJS.AES.decrypt(
                { ciphertext: CryptoJS.enc.Hex.parse(encryptedData) },
                aesKey,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            ).toString(CryptoJS.enc.Utf8);

            return decryptedData;
        } catch (err) {
            console.error('Error decrypting data:', err.message);
            return null;
        }
    };

    // Function to render each log entry
    const renderLog = (log) => {
        const isExpanded = expandedLogs[log.originalIndex]; // Use the original index to manage expansion
        const logClass = log.type === 'from' ? 'log-from' : 'log-to';
        const customStyle = {
            backgroundColor: 'black',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            padding: '15px',
            overflowX: 'auto',
            whiteSpace: 'pre-wrap',
            maxHeight: '400px',
            color: 'black',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            fontSize: '14px',
            lineHeight: '1.5',
        };
        try {
            const parsedLog = log.message;
            return (
                <div key={log.originalIndex} className={`log-entry ${logClass} ${isExpanded ? 'expandedd' : ''}`}>
                    <div className="log-header" onClick={() => toggleLog(log.originalIndex)}>
                        <span>{log.eventName} <span>({(log.type === "from") ? 'AristoCAST CMS' : 'AristoCAST Monitoring'})</span></span>
                        <span className="timestamp">{log.timestamp}</span>
                        <button className="toggle-button">{isExpanded ? '-' : '+'}</button>
                    </div>
                    {isExpanded && (
                        <pre className="log-message">
                            <ReactJson src={parsedLog} theme="monokai" displayDataTypes={false} style={customStyle} />
                        </pre>
                    )}
                </div>
            );
        } catch (e) {
            console.error(`Error parsing log at index ${log.originalIndex}:`, e);
            return (
                <div key={log.originalIndex} className={`log-entry error ${logClass} ${isExpanded ? 'expandedd' : ''}`}>
                    <div className="log-header" onClick={() => toggleLog(log.originalIndex)}>
                        <span>{log.eventName}</span>
                        <button className="toggle-button">{isExpanded ? '-' : '+'}</button>
                    </div>
                    {isExpanded && (
                        <pre className="log-message">{log.message}</pre>
                    )}
                </div>
            );
        }
    };

    const customStyles = {
        option: (provided) => ({ ...provided, textAlign: 'left', }),
        control: (provided) => ({ ...provided, textAlign: 'left', }),
        menu: (provided) => ({ ...provided, textAlign: 'left', }),
    };

    return (
        isInternalUser === 1 ?
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Stack direction="row" display="flex" justifyContent="flex-start" alignItems="center" spacing={1}>
                            <Select value={options.find(option => option.value === screenUiid)} onChange={handleScreenUiidChange} style={{ width: "100%" }}
                                options={options} placeholder="Select Screen Name" styles={customStyles} isClearable />
                            <Button size='small' variant='contained' color='primary' onClick={handleRequestData} sx={{ textTransform: "none" }} disabled={connected}>{buttonName}</Button>
                            <Button size='small' variant='contained' color='error' onClick={handleDisconnectClick} sx={{ textTransform: "none" }} disabled={!connected}>Disconnect</Button>
                        </Stack>

                        <h4 style={{ textAlign: "left" }}>Event logs for  the Screen UIID: <i>{screenUiid}</i></h4>
                        <hr style={{ marginTop: "-15px", backgroundColor: "#a4a8b0", height: "1px", border: "none" }} />

                        <div className='logs-container'>
                            {logs && logs.length > 0 ? (
                                logs
                                    .slice() // Create a copy of the logs array to avoid mutating state directly
                                    .sort((a, b) => b.originalIndex - a.originalIndex) // Sort logs by their original index (descending order)
                                    .map(log => renderLog(log))
                            ) : (
                                <div>No logs found</div>
                            )}
                        </div>

                        <h4 style={{ textAlign: "left" }}>History logs for  the Screen UIID: <i>{screenUiid}</i></h4>
                        <hr style={{ marginTop: "-15px", backgroundColor: "#a4a8b0", height: "1px", border: "none" }} />

                        <div className='logs-container'>
                            {historylogs && historylogs.length > 0 ? (
                                historylogs
                                    .slice() // Create a copy of the logs array to avoid mutating state directly
                                    .sort((a, b) => b.originalIndex - a.originalIndex) // Sort logs by their original index (descending order)
                                    .map(log => renderLog(log))
                            ) : (
                                <div>No logs found</div>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </> : <AccessDenied />
    )
}

export default Troubleshoot;
